module.exports = __webpack_public_path__ + "static/media/gu.68f491c6.png";